exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/ggueret/Desktop/Personnel/Angular/ares-app/~/postcss-loader?{"ident":"postcss"}!/Users/ggueret/Desktop/Personnel/Angular/ares-app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2